import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AnalyticsActions from 'app/actions/AnalyticsActions';
import AnalyticsContext from './AnalyticsContext';

export class AnalyticsContextContainer extends React.PureComponent {
  render() {
    return <AnalyticsContext {...this.props} />;
  }
}

AnalyticsContextContainer.propTypes = {
  context: ImmutablePropTypes.map.isRequired,
  contextName: PropTypes.string.isRequired,
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapDispatchToProps = dispatch => ({
  analyticsActions: bindActionCreators(AnalyticsActions, dispatch)
});

export default connect(null, mapDispatchToProps)(AnalyticsContextContainer);
